import { JWT_SUBS, LOGIN_PATH } from './common/constants/auth';

// Branch on URL: survey magic-link URLs load a minimal bundle that skips the
// full app shell (Root.js / PostOnboarding / TokenHandler). Everything else
// boots the regular app.
//
// Before either bundle loads, also handle the "survey JWT lingers on a
// non-survey URL" case. A magic-link recipient who navigates away from
// /surveys/execute/* still carries the sub:'survey' cookie. That JWT is
// gateway-scoped, so the regular boot would 403-cascade and dump them on a
// blank /onboarding redirect. Clear the cookie and bounce to /login.

const isSurveyUrl = window.location.pathname.startsWith('/surveys/execute/');

// These three helpers intentionally duplicate logic that already lives in
// common/services/token.service.js (Cookies.get / clearToken) and
// common/utils/utils.js#parseJwt. Importing the canonical versions from the
// entry point would pull js-cookie, extract-domain, axios, moment, lodash,
// and the full constants barrel into this chunk — every page load pays that
// cost before the lazy bootstrap chunks even start. Inlining keeps the entry
// bundle in the ~1KB range. If the canonical versions ever change shape,
// update these to match.

function readTokenCookie() {
  const match = document.cookie.match(/(?:^|; )token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

function decodeJwtSub(jwt) {
  try {
    const payloadB64 = jwt.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payloadB64)).sub;
  } catch (e) {
    return null;
  }
}

function clearTokenCookie() {
  const apex = window.location.hostname.split('.').slice(-2).join('.');
  document.cookie = 'token=; Max-Age=0; path=/';
  document.cookie = `token=; Max-Age=0; path=/; domain=.${apex}`;
}

const token = readTokenCookie();
if (!isSurveyUrl && token && decodeJwtSub(token) === JWT_SUBS.SURVEY) {
  clearTokenCookie();
  window.location.replace(LOGIN_PATH);
} else if (isSurveyUrl) {
  import('./bootstrap-survey');
} else {
  import('./bootstrap');
}
